import * as loaders from "loaders/legacy/legacy-stlFileLoader";
export { loaders };
export default loaders;
